export const parseNotificationContent = (content) => {
    try {
        const parsed = JSON.parse(content);
        return parsed;
    } catch {
        return { message: content };
    }
};

export const parseNotificationDateForSort = (dateString) => {
    try {
        // The date format from API is "31.08.2025 22:55" in UTC
        const [date, time] = dateString.split(' ');
        const [day, month, year] = date.split('.');
        const [hours, minutes] = time.split(':');
        // Create date in UTC then convert to local time
        return new Date(Date.UTC(year, month - 1, day, hours, minutes));
    } catch {
        return new Date(0); // Return epoch date if parsing fails
    }
};

export const formatNotificationDate = (dateString) => {
    try {
        // The date format from API is "31.08.2025 22:55" in UTC
        const [date, time] = dateString.split(' ');
        const [day, month, year] = date.split('.');
        const [hours, minutes] = time.split(':');
        // Create date in UTC then it will automatically be displayed in local time
        const dateObj = new Date(Date.UTC(year, month - 1, day, hours, minutes));

        const now = new Date();
        const diff = now - dateObj;
        const hours_diff = Math.floor(diff / (1000 * 60 * 60));

        if (hours_diff < 1) {
            const minutes_diff = Math.floor(diff / (1000 * 60));
            if (minutes_diff < 1) return 'Just now';
            return `${minutes_diff}m ago`;
        } else if (hours_diff < 24) {
            return `${hours_diff}h ago`;
        } else {
            const days_diff = Math.floor(hours_diff / 24);
            if (days_diff === 1) return 'Yesterday';
            if (days_diff < 7) return `${days_diff}d ago`;
            if (days_diff < 30) return `${Math.floor(days_diff / 7)}w ago`;
            return dateObj.toLocaleDateString();
        }
    } catch {
        return dateString;
    }
};

export const getNotificationIcon = (notificationType) => {
    switch (notificationType) {
        case 'ORDER_REQUEST':
            return 'IconShoppingBag';
        case 'MESSAGE':
            return 'IconMessage';
        default:
            return 'IconBell';
    }
};
